// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 971) return "static/chunks/971.6286ce72bc0b4e3a.js";
	if (chunkId === 21) return "static/chunks/21.2667a0d99a89290d.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "-" + {"334":"2487bdacc71686aa","609":"a39608d724d455cf","765":"ca78d5ebdd707a04","850":"06041ea3587d9991"}[chunkId] + ".js";
};